import { useEffect, useLayoutEffect, useState } from "react";
import Fields from "../components/Parameters/Fields";
import { useDispatch, useSelector } from "react-redux";
import { getBankList } from "../../store/slices/bankListSlice";
import { getErpParameters } from "../../store/slices/erpParameterSlice";
import { getParameters } from "../../store/slices/parametersSlice";
import { selectDepartment, selectDivision } from "../../common/helpers/messageHelper"
import Loading from "../components/Loading";
import { getContracts } from "../../store/slices/contractsSlice";
import appHelpers from "../../common/helpers/appHelpers";
import PageTitle from "../components/PageTitle";
import { pageTitleTexts } from "../../constants/texts/pageTitleTexts";
import useAdminCheck from "../../hooks/useAdminCheck";

export default function Parameters() {
  useAdminCheck();
  const dispatch = useDispatch();
  const { bankList } = useSelector((state) => state.bankList);
  const { erpParameter } = useSelector((state) => state.erpParameters);
  const { parameters } = useSelector((state) => state.parameters);
  const { contracts } = useSelector((state) => state.contracts);
  const { divisionList, departmentList } = useSelector((state) => state.erpValues);
  const [contractStatus, setContractStatus] = useState(false);
  const [contractsState, setContractsState] = useState({
    contactAgreement: "",
    serviceContracts: "",
    distanceSalesContracts: "",
    securityInfo: "",
    refundInfo: "",
    kvkkText: "",
  });
  const [isParameters, setIsParameters] = useState(true);

  useLayoutEffect(() => {
    dispatch(getParameters());
    dispatch(getBankList());
    dispatch(getErpParameters());
    dispatch(getContracts());
    selectDivision();
    selectDepartment();
    fetchParameterData();
  }, [])

  useEffect(() => {
    if (parameters.length < 1 || parameters == []) {
      setIsParameters(true);
    } else {
      setIsParameters(false);
    }
  }, [parameters])

  const fetchParameterData = async () => {
    const data = contracts;
    var serviceContracts = data[data?.findIndex(w => w.contracttype == 1)]?.contract;//serviceContracts
    var distanceSale = data[data?.findIndex(w => w.contracttype == 2)]?.contract;//distanceSale
    var securityInfo = data[data?.findIndex(w => w.contracttype == 3)]?.contract;//securityInfo
    var refundTerms = data[data?.findIndex(w => w.contracttype == 4)]?.contract;//refundTerms
    var kvkkContracts = data[data?.findIndex(w => w.contracttype == 5)]?.contract;//kvkkContracts
    var contactForm = data[data?.findIndex(w => w.contracttype == 6)]?.contract;//contactForm

    setContractsState({
      ...contractsState, contactAgreement: contactForm,
      distanceSalesContracts: distanceSale, serviceContracts: serviceContracts,
      securityInfo: securityInfo, kvkkText: kvkkContracts, refundInfo: refundTerms
    })

    const params = {
      licenseKey: appHelpers.getLicenceKey(),
      taxCode: appHelpers.getTaxNumber()
    }
    setContractStatus(true);
  }

  return (
    (!contractStatus || isParameters) ? (
      <Loading />
    ) : (
      <div className="w-full">
        <PageTitle title={pageTitleTexts.parameters} />
        <div className="px-4  py-2  flex flex-col justify-start space-y-1 ">
          <div className="flex flex-row items-center">
            <img src={"/icons/parameters-dark.svg"} className="h-6 w-6 black" />
            <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
              Ayarlar
            </span>
          </div>
          <Fields
            parameters={parameters} divisionList={divisionList}
            departmentList={departmentList} erpParameters={erpParameter}
            vpList={bankList} bankErpCodeMatchList={erpParameter.bankMatchList}
            contractsState={contractsState}
          />
        </div>
      </div>
    )
  );
}
